export function safeDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value).toLowerCase()
  } catch (error) {
    return ""
  }
}

export function pageLocationHasPii(pageLocation, matches) {
  if (!pageLocation || !Array.isArray(matches) || !matches.length) return false
  const normalizedLocation = pageLocation.toLowerCase()
  const decodedLocation = safeDecodeURIComponent(pageLocation)
  return matches.some((match) => {
    if (!match || typeof match !== "object") return false
    const rawValue = typeof match.value === "string" ? match.value : ""
    if (!rawValue) return false
    const value = rawValue.toLowerCase()
    if (!value) return false
    if (normalizedLocation.includes(value)) return true
    const encodedValue = encodeURIComponent(rawValue).toLowerCase()
    if (encodedValue && normalizedLocation.includes(encodedValue)) return true
    const plusValue = value.replace(/\s+/g, "+")
    if (plusValue && normalizedLocation.includes(plusValue)) return true
    return decodedLocation.includes(value)
  })
}
